module.exports = JSON.parse('{"Clear dates":"Clear dates","End Date":"End Date","Start Date":"Start Date"}')